module.exports = __webpack_public_path__ + "img/ef4.ae7b7a27.jpg";